'use strict';

module.exports = {
  admin: require('./admin'),
  'content-api': require('./content-api'),
};
